module.exports = __webpack_public_path__ + "img/to-top_icon.794f53e1.svg";